<template>
  <div class="slider-area">
    <swiper
      :slides-per-view="1"
      :space-between="0"
      ref="swiper"
      :pagination="{ el: '.main-slider-paginations', clickable: true }"
      class="swiper-container slider__active slider-wrapper"
      @slideChange="updatePagination"
    >
      <swiper-slide
        v-for="slider in slider_data"
        :key="slider.id"
        class="single-slider slider-height d-flex align-items-center"
        :style="`background-image: url(${slider.image_url})`"
      >
        <div class="container">
          <div class="row">
            <div class="col-xl-5">
              <div class="slider-content">
                <div class="slider-top-btn" data-animation="fadeInLeft" data-delay="1.5s">
                  <router-link to="/shop" class="st-btn b-radius">{{ slider.tag }}</router-link>
                </div>
                <h2 data-animation="fadeInLeft" data-delay="1.7s" class="pt-15 slider-title pb-5" v-html="slider.title">
                </h2>
                <p class="pr-20 slider_text" data-animation="fadeInLeft" data-delay="1.9s">{{ slider.text }}</p>
                <div class="slider-bottom-btn mt-75">
                  <router-link to="/shop" data-animation="fadeInUp" data-delay="1.15s" class="st-btn-b b-radius">
                    Discover now
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="main-slider-paginations"></div>
    </swiper>
  </div>
</template>

<script>

import { Swiper, SwiperSlide } from "swiper/vue";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      slider_data: [], // Holds slider data
      swiper: null, // Reference to swiper instance
    };
  },
  methods: {
    async fetchSliderData() {
      try {
        const response = await this.$axios.get("/get-sliders");
        this.slider_data = response.data; // Assign API response to slider_data
      } catch (error) {
        console.error("Failed to fetch slider data:", error);
      }
    },
    updatePagination() {
      if (this.swiper) {
        this.swiper.pagination.update();
      }
    },
  },
  mounted() {
    this.fetchSliderData().then(() => {
      if (this.$refs.swiper) {
        this.swiper = this.$refs.swiper.swiper; // Assign swiper instance
      }
    });
  },
};
</script>

<style scoped>
/* Add your styles here */
.slider-area {
  /* Custom styles for the slider area */
}

.single-slider {
  /* Custom styles for each slider */
}
</style>
